export type DiscountType = {
  name: string
  value: number
}

export const DISCOUNT_TYPE: DiscountType[] = [
  {
    name: 'None',
    value: 5,
  },
  {
    name: 'Fixed Amount',
    value: 10,
  },
  {
    name: 'Percentage',
    value: 15,
  },
]

export const getDiscountTypeValue = (name: string): number =>
  DISCOUNT_TYPE.find((item) => item.name === name)?.value || 5
